<div class="mt-6">
  <div [formGroup]="formOrigin" class="mt-4 container mx-auto">
    <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Origem</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center mb-4 -mx-2 w-full">
              <div class="btn-search-google">
                <button
                  class="btn-icon"
                  (click)="googleSearch('origin')"
                  [ngClass]="selected.id && selected.id != -1 ? 'disabled' : ''"
                  [disabled]="selected.id && selected.id != -1 ? true : false"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </div>
              <mat-form-field
                class="input-tg w-11/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="originLocal" />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center -mx-2 w-full">
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>CEP</mat-label>
                <input
                  matInput
                  formControlName="originPostalCode"
                  (input)="getAddressByPostalCode('origin')"
                  (blur)="getAddressByPostalCode('origin')"
                />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-6/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="originStreet" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Número</mat-label>
                <input matInput formControlName="originNumber" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="originNeighborhood" />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center mt-4 -mx-2 w-full">
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="originComplement" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Latitude</mat-label>
                <input matInput formControlName="originLatitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Longitude</mat-label>
                <input matInput formControlName="originLongitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Cidade</mat-label>
                <input
                  matInput
                  formControlName="originCity"
                  (blur)="searchTariff()"
                />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Estado</mat-label>
                <input
                  matInput
                  formControlName="originState"
                  (blur)="searchTariff()"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [formGroup]="formDestination" class="mt-4 container mx-auto">
    <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Destino</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center mb-4 -mx-2 w-full">
              <div class="btn-search-google">
                <button
                  class="btn-icon"
                  (click)="googleSearch('destination')"
                  [ngClass]="selected.id && selected.id != -1 ? 'disabled' : ''"
                  [disabled]="selected.id && selected.id != -1 ? true : false"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </div>
              <mat-form-field
                class="input-tg w-11/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Descrição</mat-label>
                <input matInput formControlName="destinationLocal" />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center -mx-2 w-full">
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>CEP</mat-label>
                <input
                  matInput
                  formControlName="destinationPostalCode"
                  (input)="getAddressByPostalCode('destination')"
                  (blur)="getAddressByPostalCode('destination')"
                />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-6/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="destinationStreet" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Número</mat-label>
                <input matInput formControlName="destinationNumber" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="destinationNeighborhood" />
              </mat-form-field>
            </div>
            <div class="flex justify-between items-center mt-4 -mx-2 w-full">
              <mat-form-field
                class="input-tg w-4/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="destinationComplement" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Latitude</mat-label>
                <input matInput formControlName="destinationLatitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Longitude</mat-label>
                <input matInput formControlName="destinationLongitude" />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Cidade</mat-label>
                <input
                  matInput
                  formControlName="destinationCity"
                  (blur)="searchTariff()"
                />
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Estado</mat-label>
                <input
                  matInput
                  formControlName="destinationState"
                  (blur)="searchTariff()"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [formGroup]="form" class="mt-4 container mx-auto">
    <div class="flex justify-between items-center mt-8 mb-5 -mx-2">
      <div class="w-full px-2">
        <div class="box-form">
          <h4 class="bg-gray">Tarifário</h4>
          <div class="input-box flex flex-col items-center w-full">
            <div class="flex justify-between items-center mt-4 -mx-2 w-full">
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Tipo Tarifario</mat-label>
                <mat-select
                  formControlName="tariffType"
                  (selectionChange)="searchTariff()"
                >
                  @for (type of listTariffType; track type) {
                    <mat-option [value]="type.id">{{
                      type.descricao
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Tipo Serviço</mat-label>
                <mat-select
                  formControlName="serviceType"
                  (selectionChange)="
                    onSelectionChangeServiceSpecification($event)
                  "
                >
                  <mat-option>Nenhum</mat-option>
                  @for (type of listTypeService; track type) {
                    <mat-option [value]="type.id">{{
                      type.descricao
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Serviço</mat-label>
                <mat-select
                  formControlName="specificationService"
                  (selectionChange)="onSelectionChangeService($event)"
                >
                  <mat-option>Nenhum</mat-option>
                  @if (listServiceSpecification.length == 0) {
                    <mat-option disabled>Nenhum registro.</mat-option>
                  } @else {
                    @for (type of listServiceSpecification; track type) {
                      <mat-option [value]="type.id">{{
                        type.descricao
                      }}</mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Tipo veículo</mat-label>
                <mat-select
                  formControlName="vehicleType"
                  (selectionChange)="searchTariff()"
                >
                  <mat-option>Nenhum</mat-option>
                  @for (type of listTypeVehicle; track type) {
                    <mat-option [value]="type.id">{{
                      type.descricao
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="input-tg w-2/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Tipo motorista</mat-label>
                <mat-select
                  formControlName="driverType"
                  (selectionChange)="searchTariff()"
                >
                  <mat-option>Nenhum</mat-option>
                  @for (type of listTypeDriver; track type) {
                    <mat-option [value]="type.id">{{
                      type.descricao
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="input-tg w-1/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Perimetro Urbano</mat-label>
                <mat-select
                  formControlName="urbanPerimeter"
                  (selectionChange)="searchTariff()"
                >
                  @for (type of listPerimeter; track type) {
                    <mat-option [value]="type.value">{{
                      type.description
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (!viewOnly) {
  <mat-accordion>
    <mat-expansion-panel [expanded]="tableView">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>Tarifários</h4>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        @if (!loading) {
          <div>
            <table-list-tariff-select
              [dataSource]="itemsList"
              [columns]="columns"
              [multiSelect]="multiSelect"
              [selected]="selected"
              [listSelected]="listSelected"
              (selectItem)="selectItem($event)"
              [disabled]="proposal.statusId == 1"
            />
          </div>
          <div>
            @if (itemsList.length > 0) {
              <pagination
                [currentPage]="page"
                [pageSize]="rows"
                [totalRecords]="numberRows"
                (pageChanged)="pageChanged($event)"
              />
            }
          </div>
        } @else {
          <div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
      </div>
    </mat-expansion-panel>
  </mat-accordion>
}
